if (!customElements.get('ee-reasons-accordion')) {
  class EeReasonsAccordion extends HTMLElement {
    connectedCallback() {
      this.allowMultiple = this.dataset.allowMultiple !== 'false';
      this.entries = Array.from(this.querySelectorAll('.ee-reasons__item')).map((item) => ({
        trigger: item.querySelector('.ee-reasons__trigger'),
        panel: item.querySelector('.ee-reasons__panel'),
      }));

      this.handleResize = () => this.syncHeights();

      this.entries.forEach((entry) => {
        if (!entry.trigger || !entry.panel) return;

        entry.trigger.addEventListener('click', () => this.toggle(entry));

        if (entry.trigger.getAttribute('aria-expanded') === 'true') {
          this.expand(entry);
        }
      });

      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      if (this.handleResize) window.removeEventListener('resize', this.handleResize);
    }

    toggle(entry) {
      const isOpen = entry.trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        this.collapse(entry);
        return;
      }

      if (!this.allowMultiple) {
        this.entries.forEach((other) => {
          if (other !== entry) this.collapse(other);
        });
      }

      this.expand(entry);
    }

    expand(entry) {
      if (!entry.trigger || !entry.panel) return;
      entry.trigger.setAttribute('aria-expanded', 'true');
      entry.panel.style.maxHeight = `${entry.panel.scrollHeight}px`;
    }

    collapse(entry) {
      if (!entry.trigger || !entry.panel) return;
      entry.trigger.setAttribute('aria-expanded', 'false');
      entry.panel.style.maxHeight = '0px';
    }

    syncHeights() {
      this.entries.forEach((entry) => {
        if (!entry.trigger || !entry.panel) return;
        if (entry.trigger.getAttribute('aria-expanded') !== 'true') return;
        entry.panel.style.maxHeight = `${entry.panel.scrollHeight}px`;
      });
    }
  }

  customElements.define('ee-reasons-accordion', EeReasonsAccordion);
}
